'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _reactVirtualized = require('react-virtualized');

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'List';

var propTypes = {
  /** ListItems to render */
  children: _propTypes2.default.node.isRequired,
  /** Optional header text */
  header: _propTypes2.default.node,
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Reference list element */
  listRef: _propTypes2.default.func,
  /** Enable virtualized list from 'react-virtualized'.
   * List will only render items that are in view
   */
  enableInfiniteScroll: _propTypes2.default.bool,
  /**
   * Specify the height of each item in the list.
   * Only works if enableInfiniteScroll is set to true.
   */
  itemHeight: _propTypes2.default.number,
  /**
   * Override the styles of the list element. Height needs to be set for inifite scroll to work.
   */
  listStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Specify amount of items to render outside the view.
   * Only works if enableInfiniteScroll is set to true.
   * Defaults to 10, increasing the amount can cause massive performance loss.
   */
  overscanRowCount: _propTypes2.default.number,
  /**
   * Optional scrolling placeholder
   * Only works if enableInfiniteScroll is set to true.
   *
   * - Single component used on every child
   *
   * - Array of components, equal to children, index rendered based on position (placeholder[index])
   */
  scrollPlaceholder: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  /** Scroll to a specific index */
  scrollToIndex: _propTypes2.default.number,
  /** Override the styles of the root element */
  style: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

var defaultProps = {
  header: null,
  headerStyle: {},
  itemHeight: 48,
  listRef: _noop2.default,
  listStyle: {},
  overscanRowCount: 10,
  scrollPlaceholder: null,
  scrollToIndex: undefined,
  style: {},
  enableInfiniteScroll: false
};

/** A wrapper for ListItems */

var List = function (_Component) {
  _inherits(List, _Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.renderRows = function (_ref2) {
      var index = _ref2.index,
          isScrolling = _ref2.isScrolling,
          key = _ref2.key,
          style = _ref2.style;
      var _this$props = _this.props,
          scrollPlaceholder = _this$props.scrollPlaceholder,
          children = _this$props.children;


      var placeholder = void 0;

      if (scrollPlaceholder) {
        placeholder = scrollPlaceholder;
      }

      if ((0, _isArray2.default)(scrollPlaceholder) && scrollPlaceholder[index]) {
        placeholder = scrollPlaceholder[index];
      }

      return _react2.default.createElement(
        'div',
        {
          key: key,
          style: style
        },
        isScrolling && placeholder ? placeholder : children[index]
      );
    }, _this.renderVirtualizedList = function () {
      var _this$props2 = _this.props,
          overscanRowCount = _this$props2.overscanRowCount,
          itemHeight = _this$props2.itemHeight,
          scrollToIndex = _this$props2.scrollToIndex,
          children = _this$props2.children;


      return _react2.default.createElement(
        _reactVirtualized.AutoSizer,
        null,
        function (_ref3) {
          var height = _ref3.height,
              width = _ref3.width;
          return _react2.default.createElement(_reactVirtualized.List, {
            height: height,
            width: width,
            overscanRowCount: overscanRowCount,
            rowCount: children.length,
            rowHeight: itemHeight,
            rowRenderer: _this.renderRows,
            scrollToIndex: scrollToIndex,
            style: _styles2.default.virtualizedList
          });
        }
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          header = _props.header,
          headerStyle = _props.headerStyle,
          itemHeight = _props.itemHeight,
          listRef = _props.listRef,
          listStyle = _props.listStyle,
          overscanRowCount = _props.overscanRowCount,
          scrollPlaceholder = _props.scrollPlaceholder,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          enableInfiniteScroll = _props.enableInfiniteScroll,
          custom = _objectWithoutProperties(_props, ['children', 'header', 'headerStyle', 'itemHeight', 'listRef', 'listStyle', 'overscanRowCount', 'scrollPlaceholder', 'scrollToIndex', 'style', 'enableInfiniteScroll']);

      return _react2.default.createElement(
        'section',
        _extends({ ref: listRef, style: _getStyles2.default.root(style) }, custom),
        header ? _react2.default.createElement(
          'h1',
          { style: _getStyles2.default.listHeader(headerStyle) },
          header
        ) : null,
        _react2.default.createElement(
          'ul',
          { style: _getStyles2.default.list(header, enableInfiniteScroll, listStyle) },
          enableInfiniteScroll ? this.renderVirtualizedList() : children
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.displayName = displayName;
List.propTypes = propTypes;
List.defaultProps = defaultProps;

exports.default = List;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/list/component.js
// module id = 830
// module chunks = 0